/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SupportedRoleSelect_proposal$ref: FragmentReference;
declare export opaque type SupportedRoleSelect_proposal$fragmentType: SupportedRoleSelect_proposal$ref;
export type SupportedRoleSelect_proposal = {|
  +databaseId: string,
  +availableSupportedRoles: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +currentlyUpdating: ?boolean,
      +node: ?{|
        +databaseId: string,
        +localizedName: string,
      |},
    |}>
  |},
  +$refType: SupportedRoleSelect_proposal$ref,
|};
export type SupportedRoleSelect_proposal$data = SupportedRoleSelect_proposal;
export type SupportedRoleSelect_proposal$key = {
  +$data?: SupportedRoleSelect_proposal$data,
  +$fragmentRefs: SupportedRoleSelect_proposal$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SupportedRoleSelect_proposal",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AvailableSupportedRolesConnection",
      "kind": "LinkedField",
      "name": "availableSupportedRoles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AvailableSupportedRolesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentlyUpdating",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "localizedName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Proposal",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '0eed57f3978c4ec0089f5ba7d6da4930';

module.exports = node;
